/**
 * Ophtalmologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: OPHT
 * Catalogue acts (NGAP Maroc): 0
 */
import { defineSpecialty } from "../types";

export const ophtalmologie = defineSpecialty(
{
  "id": "ophtalmologie",
  "label": "Ophtalmologie",
  "short": "ophtalmologi",
  "scope": "Œil, chirurgie, cataracte, rétine et chirurgie ophtalmologique",
  "aliases": [
    "OPHT"
  ],
  "doctorSpecs": [
    "Ophtalmologie"
  ],
  "featureFlag": "ux.v2.ophtalmologie",
  "theme": {
    "primary": "oklch(0.70 0.15 250)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "acuity",
      "label": "Acuité",
      "icon": "Eye",
      "route": "/clinical/acuity",
      "order": 2,
      "requires": [
        "ophthalmo"
      ]
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 3,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "surgery",
      "label": "Bloc",
      "icon": "Syringe",
      "route": "/clinical/surgery",
      "order": 4,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "acuity",
      "label": "Acuité visuelle",
      "icon": "Eye",
      "component": "VisualAcuityPanel",
      "order": 1,
      "requires": []
    },
    {
      "id": "fundus",
      "label": "Fond d'œil",
      "icon": "Scan",
      "component": "FundusPanel",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Ophtalmologie",
    "subSpecialties": [
      "Consultation",
      "Réfraction",
      "Fond d'œil",
      "Chirurgie"
    ],
    "catalogueActs": 0
  },
  "terminology": {
    "icd10": [
      "H00",
      "H10",
      "H25",
      "H40",
      "H52"
    ],
    "loinc": [
      "11524-6",
      "10160-4"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "slit-lamp",
    "fundus-camera",
    "oct-scan",
    "autorefractor"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default ophtalmologie;
